module.exports = __webpack_public_path__ + "media/images/discord-06c94a7a365048414bee168ee0453217.svg";